export default function GreyCalendarIcon() {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_9170_48258)">
        <path
          d="M19.3802 5.08138H18.5426V4.24382C18.5426 3.78315 18.1657 3.40625 17.705 3.40625C17.2444 3.40625 16.8675 3.78315 16.8675 4.24382V5.08138H8.49179V4.24382C8.49179 3.78315 8.11488 3.40625 7.65422 3.40625C7.19356 3.40625 6.81665 3.78315 6.81665 4.24382V5.08138H5.97909C5.05776 5.08138 4.30396 5.83519 4.30396 6.75652V20.1576C4.30396 21.0789 5.05776 21.8327 5.97909 21.8327H19.3802C20.3015 21.8327 21.0553 21.0789 21.0553 20.1576V6.75652C21.0553 5.83519 20.3015 5.08138 19.3802 5.08138ZM18.5426 20.1576H6.81665C6.35599 20.1576 5.97909 19.7807 5.97909 19.32V9.26922H19.3802V19.32C19.3802 19.7807 19.0032 20.1576 18.5426 20.1576Z"
          fill="#91A2BB"
        />
      </g>
      <defs>
        <clipPath id="clip0_9170_48258">
          <rect width="24" height="24" fill="white" transform="translate(0.679688 0.617188)" />
        </clipPath>
      </defs>
    </svg>
  );
}
